import { gql } from '@/utilities/gql';

export const FEED_CARD_COMPANY_FRAGMENT = gql(`
  fragment FeedCardCompanyFields on Company @_unmask {
    id
    data {
      currencyInfo
    }
    myValuation {
      fairValue
      intrinsicDiscount
    }
  }
`);
